import styled from 'styled-components';
import {BODY_TEXT_COLOR} from '../config/colors';

export const AddressWrapperDiv = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1;
`;

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${BODY_TEXT_COLOR};
    text-align: center;
    font-weight: 700;
    font-family: 'Futura-Bold';
    padding: 7px 0;
`;

export const KioskHeaderDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${BODY_TEXT_COLOR};
    text-align: center;
    font-weight: 700;
    font-family: 'Futura-Bold';
    padding: 45px 0;
`;

export const HeaderTitleDiv = styled.div`
    font-size: 31px;
`;

export const KioskHeaderTitleDiv = styled.div`
    font-size: 65px;
`;

export const HeaderIconImg = styled.img`
    width: ${props => (props.styles ? props.styles.width : '35px')};
    height: ${props => (props.styles ? props.styles.height : '35px')};
    padding: 0 15px 0 0;
`;

export const ButtonWrapper = styled.div` 
    margin: 20px auto;
    position: relative;
    text-align: center;
`;
export const KioskButtonWrapper = styled.div` 
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
`;



// WEBPACK FOOTER //
// ./src/pages/styled-components.js